export default "__VITE_ASSET__DOpmiuSk__"